export const DEFAULT_PROGRAM_TITLE_SIZE = 25;

export const PROGRAM_TITLE_SIZE_OPTIONS = [
  { value: 18, label: 'Маленький' },
  { value: 22, label: 'Чуть меньше' },
  { value: 25, label: 'Обычный' },
  { value: 28, label: 'Чуть больше' },
  { value: 32, label: 'Большой' },
  { value: 40, label: 'Очень большой' }
];

export const normalizeProgramTitleSize = (value) => {
  const size = Number.parseInt(value, 10);
  return PROGRAM_TITLE_SIZE_OPTIONS.some((option) => option.value === size)
    ? size
    : DEFAULT_PROGRAM_TITLE_SIZE;
};

export const createEmptyProgram = () => ({
  clientKey: `new-${Date.now()}-${Math.random().toString(36).slice(2)}`,
  id: null,
  title: '',
  date: '',
  format: '',
  location: '',
  titleVisible: true,
  titleSize: DEFAULT_PROGRAM_TITLE_SIZE,
  events: []
});

export const getProgramTabLabel = (program, index) => {
  const title = program.title?.trim();
  return title || `Документ (${index + 1})`;
};

export const normalizeProgramsFromApi = (sections = []) =>
  sections.map((section) => ({
    clientKey: `section-${section.id}`,
    id: section.id,
    title: section.title || '',
    date: section.date || '',
    format: section.format || '',
    location: section.location || '',
    titleVisible: section.titleVisible !== false,
    titleSize: normalizeProgramTitleSize(section.titleSize),
    events: (section.events || []).map((event) => ({
      EventDate: event.EventDate || '',
      Event: event.Event || '',
      Speakers: event.Speakers || '',
      isSelected: Boolean(event.isSelected)
    }))
  }));

export const serializeProgramsForApi = (programs) =>
  programs.map((program) => ({
    id: program.id,
    title: program.title || '',
    date: program.date || '',
    format: program.format || '',
    location: program.location || '',
    titleVisible: program.titleVisible !== false,
    titleSize: normalizeProgramTitleSize(program.titleSize),
    events: (program.events || []).map((event) => ({
      EventDate: event.EventDate || '',
      Event: event.Event || '',
      Speakers: event.Speakers || '',
      isSelected: Boolean(event.isSelected)
    }))
  }));

export const getProgramsSnapshot = (programs = []) =>
  JSON.stringify(serializeProgramsForApi(programs));
